import service from './http'
/**
 * 渠道课程相关接口
 */
// 课程详细
export function catalogList(data) {
  return service({
    url: '/catalog/findList',
    method: 'get',
    params: data,
    headers: {
      Authorization: localStorage.getItem('shangke_token')
    }
  })
}

//  课程目录详情接口
export function catalogInfo(data) {
  return service({
    url: '/catalog/findInfo',
    method: 'get',
    params: data,
    headers: {
      Authorization: localStorage.getItem('shangke_token')
    }
  })
}


/**
 * 渠道课程相关接口
 */
// 课程资料列表
export function GetDatumList(data) {
  return service({
    url: '/datum/findList',
    method: 'get',
    params: data,
    headers: {
      Authorization: localStorage.getItem('shangke_token')
    }
  })
}

//  课程详情
export function GetCourseInfo(data) {
  return service({
    url: '/course/findInfo',
    method: 'get',
    params: data,
    headers: {
      Authorization: localStorage.getItem('shangke_token')
    }
  })
}

// 我的题库列表 
export function examinationList(data) {
  return service({
    url: '/examination/findList',
    method: 'get',
    params: data,
    headers: {
      Authorization: localStorage.getItem('shangke_token') || ''
    }
  })
}

// 视频详情接口
export function CourseGoodsDetail(data) {
  return service({
    url: '/courseGoods/findInfo',
    method: 'get',
    params: data,
    headers: {
      Authorization: localStorage.getItem('shangke_token') || ''
    }
  })
}

// 课程视频列表接口
export function getCourseGoodsList(data) {
  return service({
    url: '/courseGoods/findList',
    method: 'get',
    params: data,
    headers: {
      Authorization: localStorage.getItem('shangke_token') || ''
    }
  })
}
// 添加学习记录
// export function AddLearnlod(data) {
//   return service({
//     url: '/courseGoodsLearnLog/editPost',
//     method: 'post',
//     data: data,
//     headers: {
//       Authorization: localStorage.getItem('shangke_token') || ''
//     }
//   })
// }


import {
  postRequest
} from './axios'

//异步添加学习视频记录
export const AddLearnlod = (data) => {
  return postRequest('/courseGoodsLearnLog/editPost', data)
}






//  获取阔知网加密播放器token接口
export function videoToken(data) {
  return service({
    url: '/public/getVideoToken',
    method: 'post',
    data: data
  })
}

// //  获取阔知网加密播放器token接口
// export function videoToken(data) {
//   return service({
//     url: '/api/video_detail',
//     method: 'post',
//     data: data
//   })
// }